module.exports = __webpack_public_path__ + "img/serviceAWSTranscribe-create.0aeba2fa.svg";